module.exports = __webpack_public_path__ + "static/media/intro-chatbot.2f99d062.png";